import React, { useContext, useMemo, useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { completeNewPasswordChallenge } from '../../utils/cognitoAuth';
import { evaluatePasswordPolicy } from '../../utils/passwordPolicy';
import PasswordPolicyChecklist from './PasswordPolicyChecklist';

const ForceChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { handleLogin } = useContext(AuthContext);
  const remember = Boolean(location.state?.remember);
  const passwordPolicy = useMemo(() => evaluatePasswordPolicy(newPassword), [newPassword]);

  const onFinish = async ({ newPassword, confirmPassword }) => {
    if (newPassword !== confirmPassword) {
      message.error('As senhas nao conferem.');
      return;
    }

    setLoading(true);
    try {
      const session = await completeNewPasswordChallenge({ newPassword });
      handleLogin({
        accessToken: session.accessToken,
        refreshToken: null,
        remember,
      });
      message.success('Senha alterada com sucesso.');
    } catch (error) {
      const errorMessage = error?.message || 'Nao foi possivel concluir a troca de senha.';
      message.error(errorMessage);
      const mustReturnToLogin = errorMessage.includes('expirado') || errorMessage.includes('Faca login novamente');
      if (mustReturnToLogin) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Troca obrigatoria de senha</h2>
      <Form form={form} onFinish={onFinish} className="login-form" layout="vertical">
        <Form.Item
          name="newPassword"
          label="Nova senha"
          rules={[
            { required: true, message: 'Informe a nova senha.' },
            {
              validator: (_, value) => {
                const policy = evaluatePasswordPolicy(value);
                if (policy.isValid) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('A senha nao atende a politica.'));
              },
            },
          ]}
          className="login-form-item"
        >
          <Input.Password
            placeholder="Nova senha"
            autoComplete="new-password"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
          />
        </Form.Item>
        <PasswordPolicyChecklist password={newPassword} />

        <Form.Item
          name="confirmPassword"
          label="Confirmar nova senha"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Confirme a nova senha.' },
            ({ getFieldValue }) => ({
              validator: (_, value) => {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('As senhas nao conferem.'));
              },
            }),
          ]}
          className="login-form-item"
        >
          <Input.Password placeholder="Confirmar nova senha" autoComplete="new-password" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!passwordPolicy.isValid}
            className="login-button"
          >
            Confirmar troca
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ForceChangePassword;
